import { Box, Button, CardMedia, Grid, Typography } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import './OurService.css'

const OurService = (props) => {
    const { _id, name, img, firstDescribe } = props.service;
    return (
        <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box sx={{ pb: 6 }}>
                <CardMedia
                    id="service-image"
                    sx={{ pt: 4, pb: 1 }}
                    component="img"
                    image={img}
                    alt="green iguana"
                />
                <Box sx={{ textAlign: 'left' }}>
                    <Typography sx={{ pb: 1, pt: 2, color: '#000D83', fontSize: '31px' }} variant="h6" id="card-name" component="div">
                        {name}
                    </Typography>
                    <Typography sx={{ color: '#5B5B5B', pb: 5, fontSize: '16px' }} variant="body3" id="card-details" component="div">
                        {firstDescribe}
                    </Typography>
                    <NavLink to={`/services/${_id}`} style={{ textDecoration: 'none' }}>
                        <Button sx={{ textDecoration: 'none', fontSize: '18px', lineHeight: '27px', color: "#000D83", fontWeight: 600, width: '150px', height: '42px', border: '1px solid #000D83', mr: 3 }} style={{ textTransform: 'capitalize' }} id="service-button">
                            Know More
                        </Button>
                    </NavLink>
                </Box>
            </Box>
        </Grid>
    );
};

export default OurService;